"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const index_1 = __importDefault(require("../../atoms/TabsOverflowButton/index"));
const index_2 = __importDefault(require("../../atoms/TabsOverflowMenu/index"));
function TabsOverflowPanel(props) {
    const { children, className, opened } = props;
    const [overflowMenuOpen, setOverflowMenuOpen] = (0, react_1.useState)(opened);
    const toggleOverflowMenuOpen = (0, react_1.useCallback)(() => {
        setOverflowMenuOpen(opened === undefined ? !overflowMenuOpen : opened);
    }, [opened, overflowMenuOpen]);
    return ((0, jsx_runtime_1.jsxs)(Container, { className: className, children: [(0, jsx_runtime_1.jsx)(Button, { count: react_1.Children.count(children), onClick: toggleOverflowMenuOpen }), overflowMenuOpen && (0, jsx_runtime_1.jsx)(index_2.default, { children: children })] }));
}
exports.default = TabsOverflowPanel;
const Container = styled_components_1.default.div `
  position: relative;

  background-color: ${props => props.theme.tabs.overflow.background};
`;
const Button = (0, styled_components_1.default)(index_1.default) `
  height: 100%;
`;
